<template>

  <v-card justify-center>
    <v-card-title>
      <b>{{ $t('program_deadline.extensions') }}</b>
    </v-card-title>
    <v-data-table :items="produljenja"
                  :headers="headersProduljenja()"
                  class="elevation-1 half-width"
                  dense
                  hide-actions
                  header-cell="{text: 'asas'}">

      <template v-slot:items="props">
        <td class="text-center"> {{props.item.DatumOd}} </td>
        <td class="text-center"> {{props.item.DatumDo}} </td>
      </template>
    </v-data-table>
  </v-card>

</template>

<script>
  export default {
    name: 'ExtensionsTable.vue',
    props: {
      produljenja: null
    },

    methods: {
      headersProduljenja() {
        return [
          {
            sortable: false,
            text: this.$t('program_deadline.table_extension_headers.start_date'),
            value: 'DatumOd',
            align: 'center'
          },
          {
            sortable: false,
            text: this.$t('program_deadline.table_extension_headers.end_date'),
            value: 'DatumDo',
            align: 'center'
          },

        ];
      }
    }

  }

</script>


<style>
  .half-width {
    /*width: 50%;*/
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Education/program_deadline_components/ExtensionsTable.vue